<template>
	<div class="faux-modal flex bg-matins flex--center flex--align">
		<div class="faux-modal__body bg-primary p pt-3">
			<div class="faux-modal__wrapper center">
				<div class="faux-modal__header text-center">
					<a href="/" class="inline-block">
						<inline svg="logos/stacked-logo" />
					</a>
				</div>
				<slot />
			</div>
		</div>
		<c-tasteful-branch-name />
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import CTastefulBranchName from '../components/embeds/TastefulBranchName.vue';

	export default Vue.extend({
		components: {
			CTastefulBranchName
		}
	});
</script>

<style lang="scss">
	@mixin contain-until($breakpoint) {
		width: 100%;
		min-height: 100vh;

		@include b-up($breakpoint) {
			max-width: $breakpoint - 75px;
			min-height: 0;
			margin: 1em 0;
		}
	}

	.faux-modal {
		min-height: 100vh;
		overflow: auto;

		.i-stacked-logo {
			width: 128px;
		}
	}
</style>